import type { PropertyValue } from 'state/data/dataState';

/**
 * A helper function that filters out properties unrelated to the current proposal.
 * Properties updated in proposals are stored in properties _PROPOSAL_{proposalId:N}_{propertyName}
 * If there is no proposed change for a given property, the origin is returned (property without _PROPOSAL prefix),
 * Otherwise the proposed value is returned with the real {propertyName} key (the value is substitited by proposed one).
 * If given proposalId is undefined, return only non proposal properties
 * Returns Record<string, PropertyValue>
 */
export const getSemNodeProperties = (
  proposalId: string | undefined,
  propertiesToUpdate: Record<string, PropertyValue>
): Record<string, PropertyValue> => {
  const targetProposalPrefix = proposalId ? `_PROPOSAL_${proposalId.replaceAll('-', '')}_` : null;

  const result: Record<string, PropertyValue> = {};
  const generalProposalPrefix = '_PROPOSAL_';

  // 1. First Pass: Collect all ORIGINAL properties
  for (const key in propertiesToUpdate) {
    if (!key.startsWith(generalProposalPrefix)) {
      result[key] = propertiesToUpdate[key];
    }
  }

  // 2. Second Pass: Apply PROPOSED overrides (Only if proposalId is present)
  if (targetProposalPrefix) {
    for (const key in propertiesToUpdate) {
      if (key.startsWith(targetProposalPrefix)) {
        const realName = key.slice(targetProposalPrefix.length);

        // This guarantees the proposal value overwrites the original
        result[realName] = propertiesToUpdate[key];
      }
    }
  }

  return result;
};
